export default "__VITE_ASSET__DAFLFSAL__"